import { Modal } from '@mui/material';

import ModalStyle from '@/constants/ModalStyle';
import nf from '@/constants/nf';

/**
 * Continue = pay children who can; Cancel = no API call. Cart kept either way.
 */
export default function PartialPayModal({ open, onClose, onContinue, short, payable, busy }) {
	if (!open) return null;

	return (
		<Modal open={open} onClose={busy ? undefined : onClose} aria-labelledby='partial-pay-title'>
			<div style={ModalStyle} className='mx-4 w-full max-w-md rounded-md'>
				<h2 id='partial-pay-title' className='mb-2 text-lg font-bold text-black'>
					Not enough balance for every child
				</h2>
				<p className='mb-3 text-sm text-[var(--weak)]'>
					You can pay for students with enough deposit now. Short students stay in the cart.
				</p>
				{short?.length > 0 && (
					<ul className='mb-3 flex flex-col gap-1 text-sm'>
						{short.map((s) => (
							<li key={s.childId} className='text-black'>
								<span className='font-semibold'>
									{s.child?.member?.name || `Child #${s.childId}`}
								</span>
								{' — short '}
								{nf(s.shortfall || 0)}
							</li>
						))}
					</ul>
				)}
				{payable?.length > 0 && (
					<p className='mb-4 text-sm text-[var(--weak)]'>
						Will pay {payable.length} student{payable.length === 1 ? '' : 's'} now.
					</p>
				)}
				<div className='flex flex-col gap-2'>
					<button
						type='button'
						className='btn-actions h-11 rounded-md px-4 text-white disabled:opacity-60'
						disabled={busy || !payable?.length}
						onClick={onContinue}
					>
						Continue
					</button>
					<button
						type='button'
						className='h-11 rounded-md border border-black bg-white px-4 font-semibold text-black disabled:opacity-60'
						disabled={busy}
						onClick={onClose}
					>
						Cancel
					</button>
				</div>
			</div>
		</Modal>
	);
}
